<template>
  <v-alert
    v-if="status === 'warning'"
    type="warning"
    variant="tonal"
    density="compact"
    :class="alertClass"
  >
    <div class="d-flex align-center justify-space-between flex-wrap ga-2">
      <span>
        This audit has been idle for a while and will be paused automatically to save on tracking costs.
        Pausing never deletes your data — your history stays saved.<template v-if="canManage"> Visit the dashboard to keep it active, or pause it now.</template>
      </span>
      <div v-if="canManage" class="d-flex align-center ga-2">
        <v-btn
          size="small"
          variant="flat"
          color="warning"
          class="text-none"
          :disabled="loading"
          @click="$emit('visit')"
        >
          Visit to keep active
        </v-btn>
        <v-btn
          size="small"
          variant="text"
          class="text-none"
          :disabled="loading"
          @click="$emit('pause')"
        >
          Pause tracking now
        </v-btn>
      </div>
    </div>
  </v-alert>

  <v-alert
    v-else-if="status === 'paused'"
    type="info"
    variant="tonal"
    density="compact"
    :class="alertClass"
  >
    <div class="d-flex align-center justify-space-between flex-wrap ga-2">
      <span>
        <template v-if="pauseReason === 'auto_idle'">
          This audit was paused after a long period of inactivity and is no longer refreshing.
        </template>
        <template v-else>
          This audit is paused and is no longer refreshing.
        </template>
        <template v-if="canManage">Your history is saved — resume it any time.</template>
        <template v-else>Your history is preserved.</template>
      </span>
      <v-btn
        v-if="canManage"
        size="small"
        variant="flat"
        color="primary"
        class="text-none"
        :disabled="loading"
        @click="$emit('unpause')"
      >
        Unpause
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'AuditStatusBanner',
  props: {
    status: {
      type: String,
      default: 'active'
    },
    pauseReason: {
      type: String,
      default: null
    },
    canManage: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    alertClass: {
      type: String,
      default: 'mb-4'
    }
  },
  emits: ['visit', 'pause', 'unpause']
}
</script>
